import { render, staticRenderFns } from "./RessifApexLineChart.vue?vue&type=template&id=98004f88&"
import script from "./RessifApexLineChart.vue?vue&type=script&lang=ts&"
export * from "./RessifApexLineChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports